import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import LedCalculatorBlockViewModel = Vertica.LouisPoulsen.Application.Content.Blocks.LedCalculatorBlockViewModel;
import BlockLedCalculatorForm from '@/ui/shared/blocks/LedCalculator/BlockLedCalculatorForm.vue';
import BlockLedCalculatorSelectFixtures from '@/ui/shared/blocks/LedCalculator/BlockLedCalculatorSelectFixtures.vue';
import BlockLedCalculatorSavings from '@/ui/shared/blocks/LedCalculator/BlockLedCalculatorSavings.vue';
import {
    calculatorFormViewModel,
    fixtureDetailsDataModel,
    savingsDataModel,
    selectedFixturesModel
} from '@/ui/shared/blocks/LedCalculator/LedCalculatorTypes';
import { debounce } from 'lodash';
import CalculateWebRequest = Vertica.LouisPoulsen.Application.LedCalculator.Requests.CalculateWebRequest;
import { ledCalculatorController } from '@/services';
import BlockLedCalculatorContactForm from '@/ui/shared/blocks/LedCalculator/BlockLedCalculatorContactForm.vue';
import { useValidator } from '@/core/app.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLedCalculator',
  props: {
    initialData: null
  },
  setup(__props: any) {

const props = __props as {initialData: LedCalculatorBlockViewModel}



const model = ref<calculatorFormViewModel>(
    {
        annualOperatingHours: 0,
        annualOperatingHoursNight: 0,
        calculationPeriod: 0,
        currentLightSourceLifetime: 0,
        fixtures: 0,
        totalCostReplacementForLed: 0,
        kwhPrice: 0,
        totalCostReplacement: 0
    });

const selectedFixtures = ref<selectedFixturesModel | null>(null);
const isDirty = ref<boolean>(true);

const existingFixtureInfo = ref<fixtureDetailsDataModel | null>(null);
const upgradeFixtureInfo = ref<fixtureDetailsDataModel | null>(null);
const savingsData = ref<savingsDataModel | null>(null);

const showModal = ref<boolean>(false);

const debounceCalculate = debounce(calculate, 300);

onMounted(() => {
    model.value = {
        annualOperatingHours: props.initialData.annualOperatingHours,
        annualOperatingHoursNight: props.initialData.annualOperatingHoursNight,
        calculationPeriod: props.initialData.calculationPeriod,
        currentLightSourceLifetime: props.initialData.currentLightSourceLifetime,
        fixtures: props.initialData.fixtures,
        totalCostReplacementForLed: props.initialData.installationPrice,
        kwhPrice: props.initialData.kwhPrice,
        totalCostReplacement: props.initialData.totalCostReplacement
    };
});

const hasSelectedFixtures = computed<boolean>(() => {
    return selectedFixtures.value !== null && selectedFixtures.value.existingFixture !== null && selectedFixtures.value.ledFixture !== null;
});

const calculationPayload = computed<CalculateWebRequest | null>(() => {
    if (!hasSelectedFixtures.value) {
        return null;
    }
    return {
        ...model.value,
        fixtureId: selectedFixtures.value.existingFixture.id,
        upgradeKit: selectedFixtures.value.ledFixture.id
    };
});

function updateReplacementCost(replacementCost: string): void {
    model.value.totalCostReplacementForLed = parseInt(replacementCost, 10);
}

function onFixturesSelected(selectedFixturesValue: selectedFixturesModel): void {
    isDirty.value = true;
    selectedFixtures.value = selectedFixturesValue;
    debounceCalculate();
}

function onModelChange(): void {
    isDirty.value = true;
    debounceCalculate();
}

watch(model, onModelChange, { deep: true });
const $validator = useValidator();

function calculate(): void {
    if (calculationPayload.value === null) {
        existingFixtureInfo.value = null;
        upgradeFixtureInfo.value = null;
        savingsData.value = null;
        return;
    }
    if ($validator.errors.items.length >= 1) {
        return;
    }
    ledCalculatorController.calculate(calculationPayload.value).then(calculation => {
        existingFixtureInfo.value = {
            ...calculation.fixtureDetails,
            totalElectricityUsage: calculation.currentTotalElectricityUsage,
            totalOperatingCost: calculation.currentTotalOperatingCost
        };
        upgradeFixtureInfo.value = {
            ...calculation.ledDetails,
            totalElectricityUsage: calculation.ledTotalElectricityUsage,
            totalOperatingCost: calculation.ledTotalOperatingCost
        };
        savingsData.value = {
            returnOnInvestment: calculation.returnOnInvestment,
            savingElectricityUsage: calculation.savingElectricityUsage,
            savingElectricityUsagePercentage: calculation.savingElectricityUsagePercentage,
            savingOperatingCost: calculation.savingOperatingCost,
            savingOperatingCostPercentage: calculation.savingOperatingCostPercentage
        };
        isDirty.value = false;
    });
}

function openModal() {
    showModal.value = true;
}

function closeModal() {
    showModal.value = false;
}


return { __sfc: true,props, model, selectedFixtures, isDirty, existingFixtureInfo, upgradeFixtureInfo, savingsData, showModal, debounceCalculate, hasSelectedFixtures, calculationPayload, updateReplacementCost, onFixturesSelected, onModelChange, $validator, calculate, openModal, closeModal, BlockLedCalculatorForm, BlockLedCalculatorSelectFixtures, BlockLedCalculatorSavings, BlockLedCalculatorContactForm }
}

})